


import Button from 'react-bootstrap/Button';
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import Row from 'react-bootstrap/Row';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchRateTypeCategory } from '../dashboard/dispatch';
import { selectMonths } from '../../utils/utility';
import { ReactDialogBox } from 'react-js-dialog-box';
import { setElectricityCharges } from './dispatch';
import TimePicker from 'react-time-picker';
import 'react-time-picker/dist/TimePicker.css';

const UtilityCharges = (props) => {
    const dispatch = useDispatch();
    const data = JSON.parse(localStorage.getItem("USER_DETAILS"));
    const { RateTypeData, allDropDownData } = useSelector(state => state.dashboardReducer);
    const [openModal, setOpenModal] = useState(false);
    const [errorsMasterValue, setErrorsMasterValue] = useState({});
    const [mainRowIndex, setMainRowIndex] = useState(0);
    const [viewClick, setViewClick] = useState(false);
    const [utilityRows, setUtilityRows] = useState([
        {
            RowId: 1,
            SpecialDaysFrom: "",
            SpecialDaysEnd: "",
            SeasonStarts: 1,
            SeasonEnds: null,
            RateType: 0,
            isSubmited: false,
            seasonEndRange: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
            slabs: [{ FromRateType: null, ToRateType: null, Unit: null, Value: null, Subsidy: null }]
        }
    ]);

    useEffect(() => {
        dispatch(fetchRateTypeCategory(data));
        console.log("RateTypeData", RateTypeData?.pDATASET);
    }, []);

    const getSeasonEndRange = (startMonthIndex) => {
        const ranges = {
            0: [0, 12],   // January to March
            1: [0, 12],   // February to March
            2: [0, 12],   // March only
            3: [0, 12],   // April to August
            4: [0, 12],   // May to August
            5: [0, 12],   // June to August
            6: [0, 12],   // July to August
            7: [0, 12],   // August only
            8: [0, 12],  // September to December
            9: [0, 12],  // October to December
            10: [0, 12], // November to December
            11: [0, 12] // December only
        };
        const [start, end] = ranges[startMonthIndex];
        return selectMonths.slice(start, end);
    };

    const handleChange = (event, param, index) => {
        const { name, value } = event?.target;
        let seasonEndRange = [];
        if (param === 'SeasonStarts') {
            seasonEndRange = (getSeasonEndRange(value - 1));
        }
        setUtilityRows(prevRows =>
            prevRows.map((row, i) =>
                i === index ? { ...row, [name]: value, ...(param === 'SeasonStarts' ? { seasonEndRange } : {}) } : row
            )
        );
    };

    const validateForm = (index) => {
        const errors = {};
        if (!utilityRows[index]?.SeasonEnds) errors.SeasonEnds = 'Season To is required';
        if (!utilityRows[index]?.RateType) errors.RateType = 'Rate Type is required';
        errors.index = index;
        return errors;
    };

    const validateSlabForm = (index, currentSlabIndex) => {
        const errors = {};
        if (!utilityRows[index]?.slabs[currentSlabIndex]?.FromRateType) errors.FromRateType = 'From Type is required';
        if (!utilityRows[index]?.slabs[currentSlabIndex]?.ToRateType) errors.ToRateType = 'To Type is required';
        if (!utilityRows[index]?.slabs[currentSlabIndex]?.Unit) errors.Unit = 'Unit is required';
        if (!utilityRows[index]?.slabs[currentSlabIndex]?.Value) errors.Value = 'Value is required';
        if (!utilityRows[index]?.slabs[currentSlabIndex]?.Subsidy) errors.Subsidy = 'Subsidy is required';
        errors.index = index;
        errors.currentSlabIndex = currentSlabIndex;
        return errors;
    }

    const openSlabModal = (index, isViewClicked = false) => {
        const formErrors = validateForm(index);
        if (Object.keys(formErrors).length > 1) {
            setErrorsMasterValue(formErrors);
        } else {
            setErrorsMasterValue({});
            setMainRowIndex(index);
            setOpenModal(true);
            setViewClick(isViewClicked);
        }
    };
    const handleModalSubmit = (seasonStarts, seasonEnds, rateType) => {
        const endMonthIndex = selectMonths.indexOf(seasonEnds);
        const isNotLastMonth = seasonEnds.toUpperCase() !== 'DECEMBER';
        const nextMonthIndex = (endMonthIndex + 1) % 12;
        const newRowSeasonEndRange = getSeasonEndRange(nextMonthIndex);
        setUtilityRows(prevRows => {
            const updatedCurrentRow = {
                ...prevRows[mainRowIndex],
                SeasonStarts: selectMonths.indexOf(seasonStarts) + 1,
                SeasonEnds: prevRows[mainRowIndex].seasonEndRange.indexOf(seasonEnds) + 1,
                RateType: rateType,
                isSubmited: true,
                isDisabled: true, // Set all fields to disabled
                seasonEndRange: getSeasonEndRange(selectMonths.indexOf(seasonStarts)),
                slabs: prevRows[mainRowIndex].slabs
            };
            if (isNotLastMonth) {
                const newRow = {
                    RowId: prevRows.length + 1,
                    SpecialDaysFrom: "",
                    SpecialDaysEnd: "",
                    SeasonStarts: nextMonthIndex + 1,
                    SeasonEnds: null,
                    RateType: 0,
                    isSubmited: false,
                    isDisabled: false, // New row fields are not disabled
                    isSeasonStartsEditable: false, // Season From is not editable as before
                    seasonEndRange: newRowSeasonEndRange,
                    slabs: [{ FromRateType: null, ToRateType: null, Unit: null, Value: null, Subsidy: null }]
                };

                return [
                    ...prevRows.slice(0, mainRowIndex),
                    updatedCurrentRow,
                    newRow
                ];
            } else {
                return [
                    ...prevRows.slice(0, mainRowIndex),
                    updatedCurrentRow,
                    ...prevRows.slice(mainRowIndex + 1)
                ];
            }
        });

        setOpenModal(false);
    };
    const onCancelClick = () => {
        setUtilityRows(prevRows => {
            const updatedRows = [...prevRows];
            const initialUtilityRow = {
                RowId: mainRowIndex + 1,
                SpecialDaysFrom: "",
                SpecialDaysEnd: "",
                SeasonStarts: null,
                SeasonEnds: 0,
                RateType: 0,
                isSubmited: false,
                slabs: [{ FromRateType: null, ToRateType: null, Unit: null, Value: null, Subsidy: null }]
            };
            updatedRows[updatedRows.length - 1] = initialUtilityRow;
            return updatedRows;
        });
    }
    // Add this new function for deleting a row
    const deleteRow = (index) => {
        // Only allow deletion if there's more than one row
        if (utilityRows.length > 1) {
            setUtilityRows(prevRows => prevRows.filter((_, i) => i !== index));
        }
    };

    const addRow = () => {
        console.log("addRow", mainRowIndex);
        const updatedUtilityRows = [...utilityRows];
        let currentSlabIndex = updatedUtilityRows[mainRowIndex].slabs?.length - 1;
        let formErrors = validateSlabForm(mainRowIndex, currentSlabIndex);
        if (Object.keys(formErrors).length > 2) {
            setErrorsMasterValue(formErrors);
        } else {
            errorsMasterValue.FromRateType = null;
            errorsMasterValue.ToRateType = null;
            errorsMasterValue.Unit = null;
            errorsMasterValue.Value = null;
            errorsMasterValue.Subsidy = null;
            if (updatedUtilityRows?.length > 0 && updatedUtilityRows[mainRowIndex]?.slabs?.length < 5) {
                updatedUtilityRows[mainRowIndex].slabs.push({
                    FromRateType: null,
                    ToRateType: null,
                    Unit: null,
                    Value: null,
                    Subsidy: null
                });
                setUtilityRows(updatedUtilityRows);
            }
        }
    };

    const removeRow = (slabIndex) => {
        const updatedUtilityRows = [...utilityRows];
        if (updatedUtilityRows?.length > 0 && updatedUtilityRows[mainRowIndex].slabs.length > 1) {
            updatedUtilityRows[mainRowIndex].slabs = updatedUtilityRows[mainRowIndex].slabs.filter((_, i) => i !== slabIndex);
            setUtilityRows(updatedUtilityRows);
        }
    };

    const handleRowInputChange = (field, value, slabIndex = null) => {
        const newRows = [...utilityRows];
        if (slabIndex !== null) {
            newRows[mainRowIndex].slabs[slabIndex][field] = value;
        } else {
            newRows[mainRowIndex][field] = value;
        }
        setUtilityRows(newRows);
    };

    const onNextClick = () => {
        const result = [];
        utilityRows.forEach(item => {
            if (item.isSubmited) {
                item.slabs.forEach(slab => {
                    result.push({
                        RowId: item.RowId,
                        SpecialDaysFrom: item.SpecialDaysFrom,
                        SpecialDaysEnd: item.SpecialDaysEnd,
                        SeasonStarts: item.SeasonStarts,
                        SeasonEnds: selectMonths?.indexOf(item?.seasonEndRange[item.SeasonEnds - 1]) + 1,
                        RateType: RateTypeData?.pDATASET?.findIndex(rate => rate.RATETYPE_NAME === item.RateType) + 1,
                        FromRateType: slab.FromRateType,
                        ToRateType: slab.ToRateType,
                        Unit: slab.Unit,
                        Value: slab.Value,
                        Subsidy: slab.Subsidy
                    });
                });
            }
        });
        dispatch(setElectricityCharges(result));
        props.onClick("#OtherValue");
    }

    const handleSubmit = () => {
        const result = [];
        utilityRows.forEach(item => {
            if (item.isSubmited) {
                item.slabs.forEach(slab => {
                    result.push({
                        RowId: item.RowId,
                        SpecialDaysFrom: item.SpecialDaysFrom,
                        SpecialDaysEnd: item.SpecialDaysEnd,
                        SeasonStarts: item.SeasonStarts,
                        SeasonEnds: selectMonths?.indexOf(item?.seasonEndRange[item.SeasonEnds - 1]) + 1,
                        RateType: RateTypeData?.pDATASET?.findIndex(rate => rate.RATETYPE_NAME === item.RateType) + 1,
                        FromRateType: slab.FromRateType,
                        ToRateType: slab.ToRateType,
                        Unit: slab.Unit,
                        Value: slab.Value,
                        Subsidy: slab.Subsidy
                    });
                });
            }
        });
        dispatch(setElectricityCharges(result));
        let index = utilityRows.length - 1;
        let seasonEndMonth = (utilityRows[index]).seasonEndRange[utilityRows[index].SeasonEnds - 1];
        if (utilityRows[index].isSubmited && seasonEndMonth?.toUpperCase() == 'DECEMBER') {
            props.onClick("#OtherValue");
        }
    }

    const renderDialogue = (index) => {
        return (
            <ReactDialogBox
                closeBox={() => { setOpenModal(false) }}
                modalWidth={utilityRows[index]?.RateType?.toUpperCase() == 'TIME' ? '80%' : '70%'}
                headerBackgroundColor='#E9E9E9'
                headerTextColor='#FFFFFF'
                headerHeight='60px'
                closeButtonColor='#000000'
                bodyBackgroundColor='#FFFFFF'
                bodyTextColor='#000000'>
                <div className='bodyCardHeader dialogueBodyHeader'>
                    <div style={{ display: 'flex', flexDirection: 'column' }}>
                        <Form.Label className='robotoLight13 m-0'>Season From</Form.Label>
                        <Form.Label className='robotoRegular15'>{utilityRows[index]?.SeasonStarts ? selectMonths[utilityRows[index]?.SeasonStarts - 1] : 'January'}</Form.Label>
                    </div>
                    <div style={{ marginLeft: '75px', display: 'flex', flexDirection: 'column' }}>
                        <Form.Label className='robotoLight13 m-0'>Season To</Form.Label>
                        <Form.Label className='robotoRegular15'>{utilityRows[index]?.seasonEndRange[utilityRows[index]?.SeasonEnds - 1]}</Form.Label>
                    </div>
                    <div style={{ marginLeft: '75px', display: 'flex', flexDirection: 'column' }}>
                        <Form.Label className='robotoLight13 m-0'>Rate Type</Form.Label>
                        <Form.Label className='robotoRegular15'>{utilityRows[index]?.RateType}</Form.Label>
                    </div>
                </div>
                {utilityRows[index]?.slabs?.map((row, index) => renderSlabRow(row, index, utilityRows[index]?.slabs, utilityRows[mainRowIndex]?.RateType))}
                {
                    viewClick ? null :
                        <div className='dialogueBtn'>
                            <Button variant="primary"
                                onClick={() => { setOpenModal(false) }}>
                                Cancel
                            </Button>
                            <Button variant="primary" style={{ marginLeft: '15px' }}
                                onClick={() => { handleModalSubmit(utilityRows[index]?.SeasonStarts ? selectMonths[utilityRows[index]?.SeasonStarts - 1] : 'January', utilityRows[index]?.seasonEndRange[utilityRows[index]?.SeasonEnds - 1], utilityRows[index]?.RateType) }}>
                                Save
                            </Button>
                        </div>
                }
            </ReactDialogBox>
        )
    }

    const renderSlabRow = (row, index, slabs, rateType) => {
        const isNormalRateType = rateType === 1 || rateType === "Normal";

        return (<Row className='dialogueBody'>
            <Col md={rateType?.toUpperCase() == 'TIME' ? 3 : 2}>
                {
                    rateType?.toUpperCase() == 'TIME' ?
                        <div>
                            <Form.Label className='robotoLight13'>From Time</Form.Label>
                            <TimePicker
                                disableClock
                                format="hh:mm a"
                                clearIcon={null}
                                clockIcon={null}
                                className={["react-time-picker", "time"]}
                                style={{ width: '100%' }} // Ensure it takes full width of the container
                                onChange={(newValue) => { handleRowInputChange('FromRateType', newValue, index) }}
                                value={row?.FromRateType} />
                            {
                                errorsMasterValue.currentSlabIndex == index && errorsMasterValue.FromRateType ?
                                    <div className="robotoRegularRed13" style={{ marginLeft: '120px' }}>{'From time is required'}</div> : null
                            }
                        </div> :
                        <Form.Group as={Col} controlId="FromRateType" >
                            <Form.Label className='robotoLight13'>From Rate Type</Form.Label>
                            <Form.Control placeholder="00" className='robotoRegular15'
                                value={row?.FromRateType}
                                name="FromRateType"
                                onChange={(e) => handleRowInputChange('FromRateType', e.target.value, index)} />
                            {
                                errorsMasterValue.currentSlabIndex == index && errorsMasterValue.FromRateType ?
                                    <div className="robotoRegularRed13">{errorsMasterValue.FromRateType}</div> : null
                            }
                        </Form.Group>
                }
            </Col>
            <Col md={rateType?.toUpperCase() == 'TIME' ? 3 : 2}>
                {rateType?.toUpperCase() == 'TIME' ?
                    <div>
                        <Form.Label className='robotoLight13'>To Time</Form.Label>
                        <TimePicker
                            disableClock
                            format="hh:mm a"
                            clearIcon={null}
                            clockIcon={null}
                            className={["react-time-picker", "time"]}
                            onChange={(newValue) => { handleRowInputChange('ToRateType', newValue, index) }}
                            value={row?.ToRateType} />
                        {
                            errorsMasterValue.currentSlabIndex == index && errorsMasterValue.ToRateType ?
                                <div className="robotoRegularRed13" style={{ marginLeft: '120px' }}>{'To time is required'}</div> : null
                        }
                    </div> :
                    <Form.Group as={Col} controlId="ToRateType" >
                        <Form.Label className='robotoLight13'>To Rate Type</Form.Label>
                        <Form.Control placeholder="00" className='robotoRegular15'
                            value={row?.ToRateType}
                            name="ToRateType"
                            onChange={(e) => handleRowInputChange('ToRateType', e.target.value, index)} />
                        {
                            errorsMasterValue.currentSlabIndex == index && errorsMasterValue.ToRateType ?
                                <div className="robotoRegularRed13">{errorsMasterValue.ToRateType}</div> : null
                        }
                    </Form.Group>}
            </Col>
            <Col md={2}>
                <Form.Group as={Col} controlId="Unit">
                    <Form.Label lassName='robotoLight13'>Unit</Form.Label>
                    <Form.Select defaultValue="Choose..."
                        name="Unit"
                        value={row?.Unit}
                        onChange={(e) => handleRowInputChange('Unit', e.target.value, index)}>
                        <option value="">Select</option>
                        {/* <option value="">Per Unit</option> */}

                        {
                            allDropDownData?.pDATASET.map((item) => {
                                if (item.TYPE == 'ECUNIT')
                                    return <option value={item.ID}>{item.NAME}</option>
                            })
                        }
                    </Form.Select>
                    {
                        errorsMasterValue.currentSlabIndex == index && errorsMasterValue.Unit ?
                            <div className="robotoRegularRed13">{errorsMasterValue.Unit}</div> : null
                    }
                </Form.Group>
            </Col>
            <Col md={rateType?.toUpperCase() == 'TIME' ? 1 : 2}>
                <Form.Group as={Col} controlId="Value" >
                    <Form.Label className='robotoLight13'>Value</Form.Label>
                    <Form.Control placeholder="00" className='robotoRegular15'
                        value={row?.Value}
                        name="Value"
                        onChange={(e) => handleRowInputChange('Value', e.target.value, index)} />
                    {
                        errorsMasterValue.currentSlabIndex == index && errorsMasterValue.Value ?
                            <div className="robotoRegularRed13">{errorsMasterValue.Value}</div> : null
                    }
                </Form.Group>
            </Col>
            <Col md={rateType?.toUpperCase() == 'TIME' ? 1 : 2}>
                <Form.Group as={Col} controlId="Subsidy" >
                    <Form.Label className='robotoLight13'>Subsidy</Form.Label>
                    <Form.Control placeholder="00" className='robotoRegular15'
                        value={row?.Subsidy}
                        name="Subsidy"
                        onChange={(e) => handleRowInputChange('Subsidy', e.target.value, index)} />
                    {
                        errorsMasterValue.currentSlabIndex == index && errorsMasterValue.Subsidy ?
                            <div className="robotoRegularRed13">{errorsMasterValue.Subsidy}</div> : null
                    }
                </Form.Group>
            </Col>
            {
                viewClick ? null :
                    <Col md={2} style={{ marginTop: '30px' }}>
                        {/* Only show the add button if rate type is "Normal" */}
                        {!isNormalRateType &&
                            <img src={require('../../assets/plus.png')}
                                style={{ width: '44', height: '44', imageRendering: 'pixelated' }}
                                onClick={() => { addRow() }} />
                        }
                        {
                            slabs?.length > index ? null :
                                <img src={require('../../assets/minus.png')}
                                    style={{ width: '44', height: '44', imageRendering: 'pixelated', marginLeft: '20px' }}
                                    onClick={() => { removeRow(index) }} />
                        }
                    </Col>
            }
        </Row>)
    }

    return (
        <div>
            <div style={{ maxHeight: '70vh', overflowY: 'auto', paddingBottom: '20px', height: '50vh' }}>
                <Form>
                    {
                        (data?.pDATASET[0]?.STATE_NAME || data?.pDATASET[0]?.CIRCLE_NAME) ?
                            <div className='bodyCardHeader' style={{ paddingLeft: '20px' }}>
                                <div style={{ display: 'flex', flexDirection: 'column' }}>
                                    <Form.Label className='robotoLight13 m-0'>State</Form.Label>
                                    <Form.Label className='robotoRegular15'>{data?.pDATASET[0]?.STATE_NAME}</Form.Label>
                                </div>
                                <div style={{ marginLeft: '75px', display: 'flex', flexDirection: 'column' }}>
                                    <Form.Label className='robotoLight13 m-0'>Distict</Form.Label>
                                    <Form.Label className='robotoRegular15'>{data?.pDATASET[0]?.CIRCLE_NAME}</Form.Label>
                                </div>
                                <div style={{ marginLeft: '75px', display: 'flex', flexDirection: 'column' }}>
                                    <Form.Label className='robotoLight13 m-0'>Tariff ID</Form.Label>
                                    <Form.Label className='robotoRegular15'>{'567654'}</Form.Label>
                                </div>
                                <div style={{ marginLeft: '75px', display: 'flex', flexDirection: 'column' }}>
                                    <Form.Label className='robotoLight13 m-0'>Tariff Type</Form.Label>
                                    <Form.Label className='robotoRegular15'>{'ABCD'}</Form.Label>
                                </div>
                            </div> : null
                    }
                    {utilityRows.map((row, index) => (
                        <Row className="formRow mx-0" key={index} style={{ paddingRight: '16px' }}>
                            <Col md={3}>
                                <Form.Group as={Col} controlId={`handleChange${index}`}>
                                    <Form.Label className="robotoBoldRed13">*</Form.Label>
                                    <Form.Label className="robotoLight13">Season From</Form.Label>
                                    <Form.Select
                                        name="SeasonStarts"
                                        value={row.SeasonStarts}
                                        onChange={(e) => handleChange(e, 'SeasonStarts', index)}
                                        className="robotoRegular15"
                                        disabled>
                                        {selectMonths?.map((month, monthIndex) => (
                                            <option key={monthIndex} value={monthIndex + 1}>
                                                {month}
                                            </option>
                                        ))}
                                    </Form.Select>
                                </Form.Group>
                            </Col>
                            <Col md={3}>
                                <Form.Group as={Col} controlId={`SeasonTo_${index}`}>
                                    <Form.Label className="robotoBoldRed13">*</Form.Label>
                                    <Form.Label className="robotoLight13">Season To</Form.Label>
                                    <Form.Select
                                        name="SeasonEnds"
                                        value={row.SeasonEnds}
                                        disabled={row.isDisabled}
                                        onChange={(e) => handleChange(e, 'SeasonEnds', index)}
                                        className="robotoRegular15"
                                        isInvalid={!!errorsMasterValue.SeasonEnds && errorsMasterValue.index == index}>
                                        <option value="">Please select</option>
                                        {row?.seasonEndRange?.map((month, monthIndex) => (
                                            <option key={monthIndex} value={monthIndex + 1}>
                                                {month}
                                            </option>
                                        ))}
                                    </Form.Select>
                                    {
                                        errorsMasterValue.index == index && errorsMasterValue.SeasonEnds ?
                                            <div className="robotoRegularRed13">{errorsMasterValue.SeasonEnds}</div> : null
                                    }
                                </Form.Group>
                            </Col>
                            <Col md={3}>
                                <Form.Group as={Col} controlId={`RateType_${index}`}>
                                    <Form.Label className="robotoBoldRed13">*</Form.Label>
                                    <Form.Label className="robotoLight13">Rate Type</Form.Label>
                                    <Form.Select
                                        name="RateType"
                                        value={row.RateType}
                                        disabled={row.isDisabled}
                                        onChange={(e) => handleChange(e, 'RateType', index)}
                                        className="robotoRegular15"
                                        isInvalid={!!errorsMasterValue.RateType && errorsMasterValue.index == index}>
                                        <option value="">Please select</option>
                                        {RateTypeData?.pDATASET?.length > 0 &&
                                            RateTypeData?.pDATASET?.map((item) => (
                                                <option key={item.ID} value={item.ID}>
                                                    {item.RATETYPE_NAME}
                                                </option>
                                            ))}
                                    </Form.Select>
                                    {
                                        errorsMasterValue.index == index && errorsMasterValue.SeasonEnds ?
                                            <div className="robotoRegularRed13">{errorsMasterValue.RateType}</div> : null
                                    }
                                </Form.Group>
                            </Col>
                            <Col md={2} style={{ marginTop: '30px', flexDirection: 'row', display: row.isSubmited ? 'flex' : null }}>
                                {
                                    row.isSubmited ?
                                        <img src={require('../../assets/check.png')} style={{ width: '44', height: '44', imageRendering: 'pixelated', marginRight: '16px' }} onClick={() => { addRow() }} /> : null
                                }
                                {
                                    // Fixed condition to show delete icon for the last row
                                    index === utilityRows.length - 1 && index != 0?
                                        <img src={require('../../assets/delete.png')}
                                            style={{ width: '44', height: '44', imageRendering: 'pixelated', marginRight: '16px' }}
                                            onClick={() => { deleteRow(index) }} /> : null
                                }
                                <Button variant="primary" onClick={() => openSlabModal(index)}>
                                    configure
                                </Button>
                                {
                                    row.isSubmited ?
                                        <Button variant="primary" onClick={() => openSlabModal(index, true)} style={{ marginLeft: '16px' }}>
                                            view
                                        </Button> : null
                                }
                            </Col>
                        </Row>
                    ))}
                    {
                        utilityRows.filter((item) => item.isSubmited).length > 0 ?
                            <div className='dialogueBtn' style={{ paddingLeft: '20px' }}>
                                <Button variant="primary"
                                    onClick={() => { onCancelClick() }}>
                                    Cancel
                                </Button>
                                <Button variant="primary" style={{ marginLeft: '15px' }}
                                    onClick={() => { handleSubmit() }}>
                                    Save
                                </Button>
                                <Button variant="primary" style={{ marginLeft: '15px' }}
                                    onClick={() => { onNextClick() }}>
                                    Next
                                </Button>
                            </div> : null
                    }
                </Form>
                {openModal ? renderDialogue(mainRowIndex) : null}
            </div>
        </div>
    );
}

export default UtilityCharges;
